export default __webpack_public_path__ + "static/swearby-white-b0ee4eca3d8b177709d72e9ddf866617.svg";